/**
 * One instance per format: Intl formatters are expensive to construct and are used on every axis
 * tick and tooltip render. Both the plot axis and the tooltip show the same "aug. 30 02:00" form.
 */
export const dateTimeFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export const timeFormatter = new Intl.DateTimeFormat(undefined, {
  hour: '2-digit',
  minute: '2-digit',
});

export const valueFormatter = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 });
